/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux'

import { START } from 'pu-data/QuoteSteps';
import {
  copperInner as tooltipCopperInner,
  copperOuter as tooltipCopperOuter,
} from 'pu-data/Tooltips';


import Quantities from 'pu-react/components/Quantities';
import NumberLayer from 'pu-react/components/NumberLayer';
import BoardLength from 'pu-react/components/BoardLength';
import BoardWidth from 'pu-react/components/BoardWidth';
import MaterialThickness from 'pu-react/components/MaterialThickness';
import CopperWeight from 'pu-react/components/CopperWeight';
import MinTraceSpace from 'pu-react/components/MinTraceSpace';
import Soldermask from 'pu-react/components/Soldermask';
import Silkscreen from 'pu-react/components/Silkscreen';

import UlCertification from 'pu-react/components/UlCertification';
import DataCode from 'pu-react/components/DataCode';
import PanelApproval from 'pu-react/components/PanelApproval';
import SpecialInstruction from 'pu-react/components/SpecialInstruction';
import RequiredInformation from 'pu-react/components/RequiredInformation';

import SectionPanelized from 'pu-react/components/SectionPanelizedITV'

import InstantQuote from './form/InstantQuote';
import MaterialTypeAndFinishPlating from './form/MaterialTypeAndFinishPlating'
import SmallestHoleSizeRange from './form/SmallestHoleSizeRange';
import SectionOptions from './form/SectionOptions';
import CustomQuote from './form/CustomQuote';
import Hidden from './form/Hidden';

import {
  numberLayer,
  cooperInner,
  cooperOuter,
  MinTrace,
  solderColor,
  silkscreenColor,
} from '../data/selectOptions';
import {
  changeParameter,
  doQuote,
  updateValidatorFlag,
  validator,
} from '../fabricationSlice';

import { isParameterNameQtyValid } from 'pu-utils/validate';
import { changeGlobalParameter } from 'product_tabs/actions';

const Parameters = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    parametersCustomer,
  } = useSelector((state) => state.fabrication)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
    if (isParameterNameQtyValid(name)) dispatch(changeGlobalParameter({ name: `fabrication_${name}`, value }));
  }

  const props = {
    parameters: parametersCustomer,
    onChangeParameter,
  }

  const onQuoteRequest = () => {
    if (validator.allValid()) {
      validator.showMessages();
      dispatch(doQuote());
    } else {
      validator.showMessages();
      dispatch(updateValidatorFlag());
    }
  }

  // TODO: improve quickquote for stateless component
  // componentDidMount() {
  //   const { onChangeParameter } = this.props;
  //   if (Spree.quick_quote) {
  //     _.each(Spree.quick_quote, (value, key) => {
  //       onChangeParameter(key, value);
  //     });
  //     // TODO: improve other way raise quote after change all parameters
  //     setTimeout(() => {
  //       jQuery('form .instant-quote-top .btn-main-action').click();
  //     }, 500);
  //   }
  // }

  // const {props} = this;
  // const parameters = props.parametersCustomer;
  const groupName = 'customer';
  return (
    <div className="pcb-form-section">
      <div className="row">
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
        <div className="col-md-6 ">
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...props}
            required
            errorMessage={(
              <>
                {validator.message('Quantity', parametersCustomer.quantities, 'group_required|group_numeric|group_min:1,num')}
              </>
            )} />
        </div>
        <div className="col-12">
          <MaterialThickness
            {...props}
            groupName={groupName}
            required
            label="Board Thickness" />
        </div>
        <div className="col-12">
          <NumberLayer
            {...props}
            options={numberLayer}
            groupName={groupName} />
        </div>
        <div className="col-lg-6">
          <BoardLength
            {...props}
            label="Board Length (in)"
            groupName={groupName}
            errorMessage={validator.message('Board Length', parametersCustomer.board_length, 'required|numeric|min:0.1,num|max:20,num')} />

        </div>
        <div className="col-lg-6">
          <BoardWidth
            {...props}
            label="Board Width (in)"
            groupName={groupName}
            errorMessage={validator.message('Board Width', parametersCustomer.board_width, 'required|numeric|min:0.1,num|max:33,num')} />
        </div>
        <div className="col-md-12">
          <div id="error_board_size" />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <MaterialTypeAndFinishPlating
            {...props}
            groupName={groupName} />
        </div>
        <div className="col-md-12">
          <CopperWeight
            {...props}
            required
            template="two-cols"
            label={null}
            labelBottomInner={null}
            labelBottomOuters={null}
            tooltip={null}
            innerOptions={cooperInner}
            outerOptions={cooperOuter}
            groupName={groupName}
            tooltipInner={tooltipCopperInner}
            tooltipOuter={tooltipCopperOuter} />
        </div>
        <div className="col-md-6">
          <MinTraceSpace
            {...props}
            required
            label="Min. Trace Space"
            options={MinTrace}
            groupName={groupName} />
        </div>
        <div className="col-md-6">
          <SmallestHoleSizeRange
            {...props}
            className="smallest-hole-size"
            label="Smallest Hole Size"
            groupName={groupName} />
        </div>
        <div className="col-md-12">
          <Soldermask
            {...props}
            required
            colorOptions={solderColor}
            groupName={groupName} />
        </div>
        <div className="col-md-12">
          <Silkscreen
            {...props}
            required
            colorOptions={silkscreenColor}
            groupName={groupName} />
        </div>
      </div>
      <SectionPanelized {...props} groupName={groupName} />
      <SectionOptions>
        <div className="row">
          <div className="col-md-6 col-lg-12 col-xl-7">
            <UlCertification {...props} groupName={groupName} />
          </div>
          <div className="col-md-6 col-lg-12 col-xl-5">
            <DataCode {...props} />
          </div>
          <div className="col-12">
            <PanelApproval {...props} groupName={groupName} />
          </div>
        </div>
      </SectionOptions>
      <SpecialInstruction {...props} groupName={groupName} />
      <RequiredInformation />
      <div className="row">
        <div className="col-md-6 offset-md-6">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
      <Hidden {...props} parameters={parameters} />
      <CustomQuote {...props} />
    </div>
  );
}

export default Parameters;
